<script lang="ts">
    import { FORM__addExample__title } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";

    export let onClose: () => void;
</script>

<div
    class="flex z-10 border-b border-gray-200 p-1 py-2 uppercase text-gray-600 text-xs"
>
    <span class="flex-1">{getMessage(FORM__addExample__title)} </span>
    <button
        on:click={onClose}
        class="text-gray-700 rounded text-center w-8 h-4 text-md"
    >
        <span class="icon-close" />
    </button>
</div>
